<vault-organization-user-notifications class="tw-shrink-0"></vault-organization-user-notifications>
<vault-my-folders>
  <app-header></app-header>
</vault-my-folders>
